import React from 'react';
import { Link } from 'react-router-dom';
import { IsListEmpty, IsObjectEmpty } from '../../../utilities/CommonMethods';
import RouteEndPoints from '../../../utilities/RouteEndPoints';
import CircularProgressBar from '../../UI/CircularProgressBar/CircularProgressBar';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';
import ModuleLogo from '../../../assets/html5-module-logo.png';
import CalenderIcon from '../../../assets/icons/calendar.svg';
import ClockIcon from '../../../assets/icons/clock-blue.svg';


import classes from './LastSessionFeedback.module.css';

const LastSessionFeedback = (props) => {
    // console.log(props.feedbackData)

    const subtopicsProgress = !IsObjectEmpty(props.feedbackData) && props.feedbackData.feedbackAvailable && !IsListEmpty(props.feedbackData.subtopics)
        ? props.feedbackData.subtopics.map((subtopic, index) => {
            return (
                <div className={classes.ProgressItem} key={index}>
                    <span>{subtopic.title}</span>
                    <div className={classes.ProgressDiv}>
                        <ProgressBar styleclass="Rounded" showProgressText={true}
                            progress={subtopic.progressValue}
                            progressValue={subtopic.progressLabel} />
                    </div>
                </div>
            );
        }) : !IsListEmpty(props.feedbackData.areasOfImprovement)
            ? props.feedbackData.areasOfImprovement.map((item, index) => {
                return (
                    <div className={classes.ProgressItem} key={index}>
                        <span>{item.title}</span>
                        <div className={classes.ProgressDiv}>
                            <ProgressBar styleclass="Rounded" showProgressText={true}
                                progress={item.progressValue}
                                progressValue={item.progressLabel} />
                        </div>
                    </div>
                );
            }) : <p>Subtopics are not available.</p>;

    return (
        <div className={classes.LastSessionFeedbackContainer}>
            {props.forPerformanceTab === true ? null : <h3 className={classes.CardHeading}>Last Session Feedback</h3>}

            <div className={classes.ModuleOverviewSectionContainer}>
                <div className={[classes.ModuleOverviewCard, props.forPerformanceTab ? classes.StretchFull : ''].join(' ')}>
                    {!IsObjectEmpty(props.feedbackData) && props.feedbackData.feedbackAvailable && props.feedbackData.receivedResponsesCount > 0
                        ? <>
                            <div className={classes.ModuleDetails}>
                                {props.feedbackData.feedbackAvailable
                                    ? props.forPerformanceTab === true
                                        ? <p className={[classes.TextLink, classes.AddTopMargin].join(' ')} onClick={() => props.viewAllFeedbacksClick(6)}>VIEW ALL FEEDBACKs</p>
                                        : <Link className={classes.TextLink} to={RouteEndPoints.REPORTS_PAGE + '/daily-feedback/' + props.feedbackData.topicId}>VIEW FEEDBACK</Link>
                                    : null}

                                <p className={classes.FeedbackDate}>{props.feedbackData.date}</p>

                                <div>
                                    <h4 className={classes.TopicName}>{props.feedbackData.topicName}</h4>
                                    <p className={classes.ResponsesText}>{props.feedbackData.receivedResponsesCount} RESPONSES</p>
                                </div>

                                <div className={classes.TopicsProgressContainer}>

                                    {subtopicsProgress}

                                </div>
                            </div>
                            <div className={classes.CircularProgressBarDiv}>
                                {
                                    !IsListEmpty(props.feedbackData.subtopics) ?
                                        <CircularProgressBar
                                            styleclass={props.feedbackData.clearedDoubts.value >= 80 ? "Green" : props.feedbackData.clearedDoubts.value >= 70 ? "Yellow" : "Red"}
                                            type="percentage"
                                            progress={props.feedbackData.clearedDoubts.value}
                                            showProgressText={true}
                                            progressText={props.feedbackData.clearedDoubts.label}
                                        /> : null
                                }


                                <CircularProgressBar
                                    styleclass={props.feedbackData.overallSessionRating.value >= 80 ? "Green" : props.feedbackData.overallSessionRating.value >= 70 ? "Yellow" : "Red"}
                                    type="fraction"
                                    progress={props.feedbackData.overallSessionRating.value}
                                    value={props.feedbackData.overallSessionRating.fraction}
                                    showProgressText={true}
                                    progressText={props.feedbackData.overallSessionRating.label}
                                />
                            </div>
                        </>
                        : <div className={[classes.ModuleDetails, classes.FullWidth].join(' ')}>
                            <p className={classes.FeedbackDate}>{props.feedbackData.date}</p>

                            <div>
                                <h4 className={classes.TopicName}>{props.feedbackData.topicName}</h4>
                            </div>

                            <div className={classes.TopicsProgressContainer}>
                                <p>Feedback is not available!</p>
                            </div>
                            <div className={classes.CircularProgressBarDiv}></div>
                        </div>
                    }
                </div>
                {
                    props.forPerformanceTab === true ? null
                        : <div className={classes.ModuleReportCard}>
                            <h3>Submissions</h3>

                            {
                                !IsObjectEmpty(props.submission)
                                    ? <>
                                        <Link className={[classes.ProgressTextLink, classes.ViewAllLink].join(' ')} to={RouteEndPoints.EVALUATION_PAGE + '/'}>
                                            VIEW ALL
                                        </Link>

                                        <div className={classes.ModuleDataDiv}>
                                            <img src={ModuleLogo} alt="module logo - submissions for quiz / assignment" className={classes.ModuleLogo} />
                                            <p className={classes.AssignmentQuizName}>{props.submission.title}</p>
                                        </div>

                                        <p className={classes.DueText}>Due: </p>
                                        <div className={classes.DueDateContainer}>
                                            <div className={classes.DueDateDiv}>
                                                <img src={CalenderIcon} alt="due date icon" className={classes.DueIcon} />
                                                <p className={classes.DueText}>{props.submission.dueDate}</p>
                                            </div>

                                            <div className={classes.DueDateDiv}>
                                                <img src={ClockIcon} alt="due time icon" className={classes.DueIcon} />
                                                <p className={classes.DueText}>{props.submission.dueTime}</p>
                                            </div>
                                        </div>


                                        <div className={classes.ProgressCard}>
                                            <p className={classes.ProgressStat}>{props.submission.submissionsReceived.fraction[0]}<span> / {props.submission.submissionsReceived.fraction[1]}</span></p>
                                            <p className={classes.ProgressText}>Submissions</p>
                                            <div className={classes.ProgressBarDiv}>
                                                <ProgressBar
                                                    styleclass={props.submission.submissionsReceived.value >= 80 ? "Green"
                                                        : props.submission.submissionsReceived.value >= 70 ? "Yellow" : "Red"}
                                                    showProgressText={false} progress={props.submission.submissionsReceived.value} />
                                            </div>
                                        </div>
                                        <Link className={classes.ProgressTextLink} to={{
                                            pathname: RouteEndPoints.EVALUATION_PAGE + '/' + props.submission.type + '/' + props.submission.id
                                        }}>
                                            {props.submission.type === 'quiz' ? 'VIEW QUIZ' : 'VIEW ASSIGNMENT'}
                                        </Link>
                                    </>
                                    : <p>Submission data is not available.</p>
                            }
                        </div>
                }
            </div>
        </div >
    );
}

export default LastSessionFeedback;